import { API_BASE_URL } from '../config/apiEndpoints';

const jsonHeaders = (token) => {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

async function parseError(response) {
  let detail = '';
  try {
    const data = await response.json();
    detail = data.detail || data.message || JSON.stringify(data);
  } catch {
    detail = await response.text();
  }
  const err = new Error(typeof detail === 'string' ? detail : 'Request failed');
  err.status = response.status;
  throw err;
}

export async function validateVenueOnboardingInvite(code) {
  const trimmed = String(code || '').trim();
  const response = await fetch(
    `${API_BASE_URL}/venue-onboarding/invites/${encodeURIComponent(trimmed)}`
  );
  if (!response.ok) await parseError(response);
  return response.json();
}

export async function completeVenueOnboarding(payload) {
  const response = await fetch(`${API_BASE_URL}/venue-onboarding/complete`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload)
  });
  if (!response.ok) await parseError(response);
  return response.json();
}

export async function adminCreateVenueOnboardingInvite({ note } = {}, token) {
  const response = await fetch(`${API_BASE_URL}/admin/venue-onboarding/invites`, {
    method: 'POST',
    headers: jsonHeaders(token),
    body: JSON.stringify({ note: note || null })
  });
  if (!response.ok) await parseError(response);
  return response.json();
}

export async function adminListVenueOnboardingInvites(token, { limit = 100 } = {}) {
  const response = await fetch(
    `${API_BASE_URL}/admin/venue-onboarding/invites?limit=${limit}`,
    { headers: jsonHeaders(token) }
  );
  if (!response.ok) await parseError(response);
  return response.json();
}
